import { smartkx } from '../npm.org'

export default smartkx.firebase